import { useCallback, useEffect, useRef, useState } from "react";
import { scroller } from "react-scroll";

/**
 * Прокручивает по горизонтали все прокручиваемые предки элемента (напр. секцию
 * атрибутов на мобильном), чтобы он оказался в видимой области. Вертикальную
 * прокрутку не трогает — её делает react-scroll.
 */
const scrollHorizontallyIntoView = (target: HTMLElement) => {
  let parent = target.parentElement;

  while (parent) {
    if (parent.scrollWidth > parent.clientWidth) {
      const { overflowX } = getComputedStyle(parent);

      if (overflowX === "auto" || overflowX === "scroll") {
        const parentRect = parent.getBoundingClientRect();
        const targetRect = target.getBoundingClientRect();
        const targetCenter =
          targetRect.left - parentRect.left + parent.scrollLeft;

        parent.scrollTo({
          left: targetCenter - (parent.clientWidth - targetRect.width) / 2,
          behavior: "smooth",
        });
      }
    }

    parent = parent.parentElement;
  }
};

export const useScrollTo = (anchor?: string) => {
  const [element, scrollToElement] = useState(anchor);
  const onNotFoundRef = useRef<(() => void) | undefined>(undefined);

  const scrollTo = useCallback((el: string, onNotFound?: () => void) => {
    onNotFoundRef.current = onNotFound;
    scrollToElement(el);
  }, []);

  useEffect(() => {
    let counter = 0;

    const interval = setInterval(() => {
      const target = element ? document.getElementById(element) : null;

      if (element && target) {
        clearInterval(interval);
        scrollToElement(undefined);
        onNotFoundRef.current = undefined;

        const attrHeader = document.querySelector(
          ".attr-header",
        ) as HTMLElement;

        // .attr-header липнет под сайтовой шапкой — офсет должен учитывать обе.
        const siteHeaderHeight =
          parseFloat(
            getComputedStyle(document.documentElement).getPropertyValue(
              "--site-header-height",
            ),
          ) || 0;

        const offset = Math.round(
          attrHeader
            ? -(attrHeader.getBoundingClientRect().height + siteHeaderHeight)
            : -68,
        );

        scrollHorizontallyIntoView(target);

        scroller.scrollTo(element, {
          duration: 700,
          isDynamic: true,
          delay: 0,
          smooth: true,
          spy: true,
          // containerId: 'ContainerElementID',
          offset,
        });

        return;
      }

      // Даём элементу до ~2с на монтирование (напр. асинхронно загружаемый
      // список решений), прежде чем считать его действительно отсутствующим.
      if (++counter > 10) {
        clearInterval(interval);

        if (element) onNotFoundRef.current?.();

        scrollToElement(undefined);
        onNotFoundRef.current = undefined;
      }
    }, 200);

    return () => clearInterval(interval);
  }, [element]);

  return { scrollTo };
};
